import {
  LOCATION_CLICK,
  LOCATION_SWIPE_RIGHT,
  LOCATION_SWIPE_LEFT,
  SET_ACTIVE_LOCATION,
  LOCATION_DETAIL_SWIPE_UP,
  TOGGLE_MAP_VIEW,
  CLOSE_ZOOM
} from "./constants";

export const handleLocationClick = place => {
  return { type: LOCATION_CLICK, payload: place };
};

export const handleLocationSwipe = direction => (dispatch, getState) => {
  const {
    cardNo,
    serviceCenterLocations,
    activeLocation
  } = getState().entityZoomed;

  const placeIndex = serviceCenterLocations.indexOf(activeLocation);

  if (direction === "Left" && cardNo !== serviceCenterLocations.length - 2) {
    dispatch(_swipeLocationLeft());
    dispatch(setActiveLocation(serviceCenterLocations[placeIndex + 1]));
  } else if (direction === "Right" && cardNo !== 0) {
    dispatch(_swipeLocationRight());
    dispatch(setActiveLocation(serviceCenterLocations[placeIndex - 1]));
  } else {
    dispatch(_swipeLocationUpDown(direction));
  }
};

export const setActiveLocation = place => {
  return { type: SET_ACTIVE_LOCATION, payload: place };
};

const _swipeLocationLeft = () => {
  return { type: LOCATION_SWIPE_LEFT };
};

const _swipeLocationRight = () => {
  return { type: LOCATION_SWIPE_RIGHT };
};

const _swipeLocationUpDown = direction => {
  return { type: LOCATION_DETAIL_SWIPE_UP, payload: direction };
};

export const changeMapView = view => {
  return { type: TOGGLE_MAP_VIEW, payload: view };
};

export const closeZoom = () => {
  return {
    type: CLOSE_ZOOM
  };
};
